var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 12V10C26 5.58172 22.4183 2 18 2V2C13.5817 2 10 5.58172 10 10V12",
    stroke: "#FF0050",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75736 11.7574C0 13.5147 0 16.3431 0 22V24C0 31.5425 0 35.3137 2.34315 37.6569C4.68629 40 8.45753 40 16 40H20C27.5425 40 31.3137 40 33.6569 37.6569C36 35.3137 36 31.5425 36 24V22C36 16.3431 36 13.5147 34.2426 11.7574C32.4853 10 29.6569 10 24 10H12C6.34315 10 3.51472 10 1.75736 11.7574ZM20 24C20 22.8954 19.1046 22 18 22C16.8954 22 16 22.8954 16 24C16 25.1046 16.8954 26 18 26C19.1046 26 20 25.1046 20 24ZM12 24C12 26.6124 13.6696 28.8349 16 29.6586V34H20V29.6586C22.3304 28.8349 24 26.6124 24 24C24 20.6863 21.3137 18 18 18C14.6863 18 12 20.6863 12 24Z",
    fill: "#FF0050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingLock);
export default __webpack_public_path__ + "static/media/SettingLock.ed4381bcd19c2d9786d8a5d9bd553e63.svg";
export { ForwardRef as ReactComponent };